export default __webpack_public_path__ + "static/security-4-d30ce4dcf3443bc55ca67e91080be3a9.png";